"use strict";

var __decorate = this && this.__decorate || function (decorators, target, key, desc) {
  var c = arguments.length,
    r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
    d;
  if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = this && this.__metadata || function (k, v) {
  if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.VenueStickersSummaryDto = void 0;
const swagger_1 = require("@nestjs/swagger");
/** Counters for the venue sheet's Stickers / Check-ins cards and the Stickers screen header. Visible without check-in. */
class VenueStickersSummaryDto {}
exports.VenueStickersSummaryDto = VenueStickersSummaryDto;
__decorate([(0, swagger_1.ApiProperty)({
  description: 'Active Moments + active Notes ("Stickers at this spot").'
}), __metadata("design:type", Number)], VenueStickersSummaryDto.prototype, "stickerCount", void 0);
__decorate([(0, swagger_1.ApiProperty)(), __metadata("design:type", Number)], VenueStickersSummaryDto.prototype, "momentCount", void 0);
__decorate([(0, swagger_1.ApiProperty)(), __metadata("design:type", Number)], VenueStickersSummaryDto.prototype, "noteCount", void 0);
__decorate([(0, swagger_1.ApiProperty)({
  description: 'Check-ins in the last 30 days, including people checked in right now.'
}), __metadata("design:type", Number)], VenueStickersSummaryDto.prototype, "checkInsLast30DaysCount", void 0);
__decorate([(0, swagger_1.ApiProperty)({
  description: 'People currently checked in ("Active Now · N people").'
}), __metadata("design:type", Number)], VenueStickersSummaryDto.prototype, "activeNowCount", void 0);
__decorate([(0, swagger_1.ApiProperty)({
  description: 'Visit plans for today that have not passed ("RSVPs · N going").'
}), __metadata("design:type", Number)], VenueStickersSummaryDto.prototype, "rsvpTodayCount", void 0);
__decorate([(0, swagger_1.ApiProperty)({
  description: 'Whether the viewer is checked in here: author photos are unblurred and posting is allowed.'
}), __metadata("design:type", Boolean)], VenueStickersSummaryDto.prototype, "isViewerCheckedIn", void 0);
__decorate([(0, swagger_1.ApiProperty)({
  description: 'How long a temporary moment lasts (admin setting); the app shows it on the timer button.'
}), __metadata("design:type", Number)], VenueStickersSummaryDto.prototype, "momentLifetimeHours", void 0);
__decorate([(0, swagger_1.ApiProperty)({
  description: 'How long a temporary note lasts (admin setting).'
}), __metadata("design:type", Number)], VenueStickersSummaryDto.prototype, "noteLifetimeDays", void 0);
__decorate([(0, swagger_1.ApiProperty)({
  description: 'Whether the app\'s moment screen starts on "Keep it on my profile" (admin setting).'
}), __metadata("design:type", Boolean)], VenueStickersSummaryDto.prototype, "momentsPermanentByDefault", void 0);
__decorate([(0, swagger_1.ApiProperty)({
  description: 'Whether the app\'s note screen starts on "Keep it on my profile" (admin setting).'
}), __metadata("design:type", Boolean)], VenueStickersSummaryDto.prototype, "notesPermanentByDefault", void 0);
//# sourceMappingURL=VenueStickersSummary.dto.js.map